var ko = require('knockout');

ko.components.register('tooltip', {
  viewModel: require('./tooltip'),
  template: require('./tooltip.template')
});
